var _ = require('underscore');
var Backbone = require('backbone');
var Email = require('Email');
var Entities = require('Entities');
var Logger = require('Logger');
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;
var RecordType = EY.Consultation.Lookups.RecordType;
var Industry = new Backbone.Collection(EY.Consultation.Resources.Industry);
var ApproverPattern = /TeamMember|PartnerInCharge|EngagementQualityReviewer/i;

var send = function (options, template, to) {
    var record = options.record;
    var model = new Backbone.Model({
        id: record.id,
        shortId: record.get("shortId"),
        approvalBy: record.get('recordTypeId') === RecordType.RequiredNotification ? '' : new Date(record.get('approvalBy')).format(),
        clientName: record.get('clientName'),
        countryId: record.get('countryId'),
        createdOn: new Date(record.get('createdOn')).format(),
        creatorGivenName: record.get('creatorGivenName'),
        engagementId: record.get('engagementId'),
        engagementName: record.get('engagementName'),
        engagementValidated: record.get('engagementValidated'),
        link: record.get('link').replace(/\/$/, ''),
        partner: record.get('partner'),
        returnReason: record.get('returnReason') || '',
        deleteReason: record.get('deleteReason') || '',
        recordType: record.get('recordTypeId'),
        statusResourceKey: record.get('statusResourceKey'),
        subject: record.get('subject'),
        subtype: record.get('subtype'),
        type: record.get('type'),
        validateEngagement: record.get('validateEngagement')
    });

    to = _.uniq(to.split(',')).join(',').replace(/`/g, "'").replace(/^,|,$/g,'');
    Email.send({ model: model, template: template, to: to });
};

var email001 = function (options) {
    var record = options.record;
    var approvers = _.filter(options.approvers.toJSON(), function (approver) { return ApproverPattern.test(approver.approverGroupId); });
    var history = options.history;

    if (record.get('recordTypeId') !== RecordType.RequiredNotification && (!history.id || history.statusTypeId === StatusType.Draft)) {
        var to = _.chain(approvers).reject({ upn: '' }).pluck('upn').value().join(',');

        send(options, 'email001', to);
    }
};

var email002 = function (options) {
    var record = options.record;

    if (record.get('assignedTo') !== '' && record.get('assignedTo') !== User.upn) {
        send(options, 'email002', record.get('assignedTo'));
    }
};

var email003 = function (options) {
    var record = options.record;
    var history = options.history;
    var approvers = options.approvers.toJSON();

    if (history.statusTypeId !== record.get('statusTypeId')) {
        var to = record.get('assignedTo') + ',' + _.chain(approvers).filter(function (approver) {
            return approver.approverGroupId === 'PartnerInCharge' || approver.approverGroupId === 'EngagementQualityReviewer' && approver.upn;
        }).pluck('upn').value().join(',');

        send(options, 'email003', to);
    }
};

var email005 = function (options) {
    var record = options.record;
    var history = options.history;
    var approvers = options.history.approvers;
    if (record.get('recordTypeId') === RecordType.RequiredNotification) return;
    if (history.statusTypeId !== StatusType.Preparation) {
        var to = '';
        if (history.statusTypeId !== StatusType.UsersNotified) {
            to = _.chain(approvers).filter(function (approver) { return approver.approval && approver.upn; }).pluck('upn').value().join(',') + ',' + record.get('assignedTo');
        } else {
            var apporverTo = _.chain(options.approvers.toJSON()).filter(function (approver) { return approver.approval && approver.upn; }).pluck('upn').value().join(',');
            to = apporverTo ? apporverTo + ',' + record.get('assignedTo') : record.get('assignedTo');
        }

        send(options, 'email005', to);
    }
};

var email006 = function (options) {
    var record = options.record;
    var history = options.history;
    var approvers = _.filter(options.approvers.toJSON(), function (approver) { return ApproverPattern.test(approver.approverGroupId); });


    if (record.get('recordTypeId') !== RecordType.RequiredNotification && history.statusTypeId === StatusType.ReturnForRevision) {
        var to = _.chain(approvers).reject({ upn: '' }).pluck('upn').value().join(',');
        send(options, 'email006', to);
    }
};

var email007 = function (options) {
    var record = options.record;

    if (record.get('statusTypeId') === StatusType.Draft ||
        record.get('statusTypeId') === StatusType.ReturnForRevision) {
        send(options, 'email007', record.get('assignedTo'));
    }
};

var email008 = function (options) {
    var record = options.record;
    var history = options.history;
    var preparation = record.get('action') === 'preparation';

    if ((preparation && record.get('statusTypeId') === history.statusTypeId) ||
        (!preparation && record.get('statusTypeId') !== StatusType.Draft && record.get('statusTypeId') !== StatusType.ReturnForRevision)) {
        send(options, 'email008', record.get('assignedTo'));
    }
};

var email009 = function (options) {
    var record = options.record;
    var approvers = _.filter(options.approvers.toJSON(), function (approver) { return /TeamMember|PartnerInCharge/i.test(approver.approverGroupId); });

    if (record.get('recordTypeId') !== RecordType.RequiredNotification && record.get('statusTypeId') === StatusType.Complete) {
        var to = _.chain(approvers).reject({ upn: '' }).pluck('upn').value().join(',') + ',' + record.get('createdBy');
        
        send(options, 'email009', to);
    }
};

var email015 = function (options) {
    var record = options.record;
    var approvers = _.filter(options.approvers.toJSON(), function (approver) { return /TeamMember|PartnerInCharge/i.test(approver.approverGroupId); });

    if (record.get('statusTypeId') !== StatusType.Draft) {
        var to = _.chain(approvers).reject({ upn: '' }).pluck('upn').value().join(',') + ',' + record.get('createdBy');

        send(options, 'email015', to);
    }
};

var email016 = function (options) {
    var record = options.record;
    var history = options.history;
    var approvers = _.filter(options.approvers.toJSON(), function (approver) { return /TeamMember|PartnerInCharge/i.test(approver.approverGroupId); });
    var to = '';
    if (record.get('recordTypeId') === RecordType.RequiredNotification) 
    {
        if (history.statusTypeId === StatusType.UsersNotified) {
            to = _.chain(approvers).reject({ upn: '' }).pluck('upn').value().join(',') + ',' + record.get('createdBy');
        } else {
            to = record.get('createdBy');
        }
        send(options, 'email016', to);
    }
};

var email017 = function (options) {
    var record = options.record;
    var history = options.history;
    var source = options.history.approvers;
    var target = _.pluck(options.approvers.models, 'attributes');

    if (record.get('recordTypeId') !== RecordType.RequiredNotification && history.id && history.statusTypeId !== StatusType.Preparation) {
        var added = _.filter(target, function (obj) { return !_.findWhere(source, { upn: obj.upn }); });
        var to = _.chain(added).reject({ upn: '' }).pluck('upn').value().join(',');

        send(options, 'email017', to);
    }
};

var email019 = function (options) {
    var history = options.history;
    var record = options.record;

    if (history.statusTypeId === StatusType.Preparation) {
        send(options, 'email019', record.get('assignedTo'));
    }
};

var email021 = function (options) {
    var record = options.record;
    var approvers = options.approvers.toJSON();

    if (record.get('recordTypeId') === RecordType.RequiredNotification) {
        var pic = _.find(approvers, function(eachApprover) { return eachApprover.approverGroupId === 'PartnerInCharge'});
        var hasPICApproved = pic.approval;
        
        if(hasPICApproved) {
            var to = _.chain(approvers).filter(function (approver) {
                return (approver.approverGroupId === 'SubCountryProfessionalPractice' || approver.approverGroupId === 'RequiredNotification' || approver.approverGroupId === 'EngagementQualityReviewer' || approver.approverGroupId === 'CountryProfessionalPractice' || approver.approverGroupId === 'RegionalProfessionalPractice') && approver.upn;
            }).pluck('upn').value().join(',');
            
            send(options, 'email021', to);
        }
    }
};

var email022 = function (options) {
    var record = options.record;
    var approvers = options.approvers.toJSON();

    if (record.get('recordTypeId') === RecordType.RequiredNotification && record.get('statusTypeId') === StatusType.Complete) {
        var pic = _.find(approvers, function(eachApprover) { return eachApprover.approverGroupId === 'PartnerInCharge'});
        var to = _.chain(approvers).filter(function (approver) {
            return (approver.approverGroupId === 'TeamMember' && approver.upn);
        }).pluck('upn').value().join(',');
        
        if(to == "") to = _.uniq([pic.upn, record.get('createdBy')]).join(',')
        else to = _.uniq([pic.upn, record.get('createdBy')]).join(',') + ',' + to
        send(options, 'email022', to);
    }
}

var email023or24 = function (options) {
    var record = options.record;
    var history = options.history;
    var approvers = options.approvers.toJSON();

    if (record.get('statusTypeId') === StatusType.Complete && record.get('restricted') !== history.restricted) {
        var template = record.get('restricted') === true ? 'email023' : 'email024';
        var to = _.chain(approvers).reject({ upn: '' }).pluck('upn').value().join(',') + ',' + record.get('createdBy');
        send(options, template, to);
    }

};

var deleteNotifications = function (options) {
    email015(options); //Deleted the record
};

var submitNotifications = function (options) {
    email001(options); // New Consultation Record
    email002(options); // Consultation workflow assigned to approver
    email006(options); // Consultation record resubmitted
};

var approveNotifications = function (options) {
    email001(options); // New Consultation Record
    email002(options); // Consultation workflow assigned to approver
    email009(options); // Consultation record completed i.e. last approver approved the record
    email017(options); // New Approver added from the record
    email021(options); // RN - When PIC approves the record
};

var saveNotifications = function (options) {
    email017(options); // New Approver added from the record
    email023or24(options); // Restricted flag is changed on the record after completion.
};

var preparationNotifications = function (options) {
    email003(options); // Record submitted to Preparation phase
    email008(options); // Record reassigned to approver or review
};

var returnNotifications = function (options) {
    email005(options); // Record returned to Creator
    email016(options); // RN Record returned to Creator 
    email017(options); // New Approver added from the record
    email019(options); // Record returned to creator by reviewer
};

var reassignNotifications = function (options) {
    email007(options); //Record reassigned to creator
    email008(options); // Record reassigned to approver or review
};

var recordNotificationSync = function (options) {
    var record = options.record;
    var id = record.id;

    try {
        if (record.get("statusTypeId") === StatusType.Complete) {
            var recordNotification = new Entities.RecordNotification({ id: id });
            recordNotification.fetch().done(function () {
                if (recordNotification.get("statusTypeId") !== StatusType.Complete) {
                    var attributes = JSON.parse(JSON.stringify(record.toJSON()));
                    id = id ? id : response.id;
                    attributes.approvers = _.map(attributes.approvers,
                        function (approver) {
                            return _.pick(approver, 'approverGroupId', 'approval', 'geographyId', 'gpn', 'rank', 'upn');
                        });
                    attributes.industry = record.get('industryId') ? Industry.get(record.get('industryId')).get('name') : '';
                    (new Entities.RecordNotification(_.extend(attributes, { id: id }))).save();

                    Logger.log('Notification sync update Record' + id);
                }
            });
        }
    } catch (e) {
        Logger.log('Notification sync update error', e);
    }
};
var redbox = function (options) {
    var record = options.record;
    var id = record.id;

    try {
        record.on('sync',
            function (model, response) {
                if (_.has(response, 'id')) {
                    var attributes = JSON.parse(JSON.stringify(record.toJSON()));
                    attributes.approvers = _.map(attributes.approvers,
                        function (approver) {
                            return _.pick(approver, 'approverGroupId', 'approval', 'geographyId', 'gpn', 'rank', 'upn');
                        });
                    attributes.industry = record.get('industryId') ? Industry.get(record.get('industryId')).get('name') : '';
                    (new Entities.RecordNotification(_.extend(attributes, { id: id }))).save();
                    // Record Id will be generated only after successful save or creation of the record.
                    // Hence this method will be invoked twice to save the 'id' on the second time.
                    // Setting 'id' value to make sure id is available when the sync event is called for the second time.
                    // This is to ensure to make a POST call for the first time and PUT call for the rest.
                    id = response.id; 
                } else {
                    new Entities.RecordNotification({ id: id }).destroy();
                }
            });
    } catch (e) {
        Logger.log('Notification error', e);
    }
};
module.exports.start = function (options) {
    var record = options.record;

    redbox(options);
    recordNotificationSync(options);
    record.on('change:action', function (model, action) {
        switch (action) {
            case 'delete':
                deleteNotifications(options);
                (new Entities.RecordNotification({ id: model.id })).destroy();
                break;
            case 'submit':
                submitNotifications(options);
                break;
            case 'approve':
                approveNotifications(options);
                break;
            case 'save':
                saveNotifications(options);
                break;
            case 'preparation':
                preparationNotifications(options);
                break;
            case 'return':
                returnNotifications(options);
                break;
            case 'reassign':
                reassignNotifications(options);
                break;
            case 'acknowledge':
                email022(options);
                break;
        }
        EY.Consultation.Lookups.IsHandHeldDevice &&
            Logger.logToServer(JSON.stringify({
                device: EY.Consultation.Lookups.IsHandHeldDevice[0],
                rank: EY.Consultation.CurrentUser.rank,
                location: EY.Consultation.CurrentUser.location.country,
                action: action
            }), 'handHeldDevice');
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordNotification.js